import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DefaultBook from "../Images/defaultBook.png";
import bookmarkedicon from "../Images/bookmarked.svg";
import { FavGotoTopButton } from "./FavGotoTopButton";

interface MarkListProps {
  bookMarks: any[];
  marktitle: string;
  getMarks: (value: any) => void;
}

export const MarkList: React.FC<MarkListProps> = ({
  bookMarks,
  marktitle,
  getMarks,
}) => {
  const [displayCount, setDisplayCount] = useState(4);

  const showMoreBooks = () => {
    setDisplayCount(bookMarks?.length); // Increase by a certain number
  };

  const showLessBooks = () => {
    setDisplayCount(4); // Reset to initial display count
  };

  const { t } = useTranslation();

  return (
    <div>
      {bookMarks?.length > 0 ? (
        <div>
          <div>
            <p
              style={{
                fontFamily: "ChanakyaUni",
                fontWeight: 700,
                fontStyle: "normal",
                color: "#b42a38",
                fontSize: "26px",
                margin: "0 0 10px",
              }}
            >
              {marktitle}
            </p>
            <div className="row" style={{ marginBottom: "21px", padding: "0 15px" }}>
              {bookMarks.slice(0, displayCount).map((mark: any) => (
                <div className="col-3" style={{ marginTop: "15px" }}>
                  <div
                    className="favebooks"
                    key={`related-${mark.id}`}
                    onClick={() => {
                      getMarks(mark);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <img
                          src={bookmarkedicon}
                          alt=""
                          style={{
                            margin: "0 0 -52px 80px",
                            width: "20px",
                            position: "relative",
                          }}
                        />
                        <img
                          style={{
                            cursor: "pointer",
                            borderRadius: "5px",
                          }}
                          className="imgcenter"
                          src={mark.path}
                          onError={(e) => {
                            e.currentTarget.src = DefaultBook;
                          }}
                          alt={mark.name}
                          title={mark.name}
                          width="117"
                          height="165"
                        />
                        <p>
                          {mark?.name?.length > 40
                            ? mark?.name.slice(0, 30) + "..."
                            : mark?.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="fav-section-actions">
            {bookMarks?.length > 4 &&
              (displayCount < bookMarks?.length ? (
                <button className="favitems" onClick={showMoreBooks}>
                  {t("all_tr")} {bookMarks?.length} {t("bk_mark_tr")}{" "}
                  {t("view_tr")}
                </button>
              ) : (
                <button className="favitems" onClick={showLessBooks}>
                  {t("show_less_tr")}
                </button>
              ))}
            <FavGotoTopButton />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}; 